export default __webpack_public_path__ + "static/media/no_orders.8fc293d8.svg";